import e from"react";const r=e.createContext({});function t({value:t,children:n}){return e.createElement(r.Provider,{value:t},n)}export{r as ConfigContext,t as ConfigProvider};
//# sourceMappingURL=ConfigProvider.js.map
